var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWandrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: 192,
    height: 192,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2dd4bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22c55e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 8) scale(1.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 20 L18.5 50 L32 33 L45.5 50 L57 20",
    fill: "none",
    stroke: "url(#g)",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 33 C27.5 26.5 23.5 22.5 23.5 17 A8.5 8.5 0 0 1 40.5 17 C40.5 22.5 36.5 26.5 32 33 Z M35.3 16.8 A3.3 3.3 0 1 0 28.7 16.8 A3.3 3.3 0 1 0 35.3 16.8 Z",
    fill: "url(#g)",
    fillRule: "evenodd"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 176,
    textAnchor: "middle",
    fontFamily: "Sora, Manrope, 'Segoe UI', Arial, sans-serif",
    fontSize: 38,
    fontWeight: 800,
    letterSpacing: 1,
    fill: "url(#g)"
  }, "Wandr")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandrLogo);
export default __webpack_public_path__ + "static/media/wandr-logo.24ade80276afff6c2b7d87cc8ce898d6.svg";
export { ForwardRef as ReactComponent };